import git from './utils/git.json';

export const B = {
    BACKEND_HOST: import.meta.env.VITE_BACKEND_HOST,
    INGESTION_HOST: import.meta.env.VITE_INGESTION_HOST,
    MATERIALIZED_HOST: import.meta.env.VITE_MATERIALIZED_HOST,
    AGENT_CHAT_HOST: import.meta.env.VITE_AGENT_CHAT_HOST,
    PREVIEW_ID: import.meta.env.VITE_PREVIEW_ID || '',
    DJANGO_GCP_STATIC_BUCKET: import.meta.env.VITE_DJANGO_GCP_STATIC_BUCKET,

    APP_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || '?',
    APP_CUSTOMER: import.meta.env.VITE_CUSTOMER || '?',
    APP_URL: import.meta.env.VITE_URL || 'http://localhost:3008',
    APP_IS_DEV: Boolean(import.meta.env.DEV),
    APP_ROLLBAR_ACCESS_TOKEN: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN || '',
    APP_VERSION: git.gitCommitHash || '',
    APP_PING_INTERVAL: import.meta.env.VITE_PING_INTERVAL || '',

    AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
    AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN || '',
    AUTH0_ORGANIZATION: import.meta.env.VITE_AUTH0_ORGANIZATION || '',

    FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY || '',
    FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID || '',
    FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',

    FRONTEGG_APPLICATION_ID: import.meta.env.VITE_FRONTEGG_APPLICATION_ID || '',
    FRONTEGG_CLIENT_ID: import.meta.env.VITE_FRONTEGG_CLIENT_ID || '',
    FRONTEGG_DOMAIN: import.meta.env.VITE_FRONTEGG_DOMAIN || '',

    UNDER_CONSTRUCTION: Boolean(import.meta.env.VITE_UNDER_CONSTRUCTION || ''),
    DISABLE_APPLICATION: Boolean(import.meta.env.VITE_DISABLE_APP || ''),
}

/**
 * staging or dev environment
 */
export const ONLY_FOR_US: true | undefined = B.APP_ENVIRONMENT === 'staging' || B.APP_IS_DEV || undefined;

export const ONLY_PRODUCTION: true | undefined = B.APP_ENVIRONMENT === 'production' ? true : undefined;
